import React from 'react';
import Logo from '../../Assets/Logo1-min.png';
import styles from './login.module.css';
import { Link } from 'react-router-dom';


function SignupLeft() {
    return (
        <div className={styles.Couple_image}>
            <div>
                    <img className={styles.logo_img} src={Logo} alt="Aphrodite logo"/>
            </div>
            <div className = {styles.Couple_content}>
              <h1 className = {styles.h1}> Its match-up time </h1>
               <h2>
                 Swipe through and get matched anywhere and <br/>
                 anytime on <span className = {styles.span}> Aphrodite </span>
               </h2>
               <p className = {styles.p}>
                Don't have an account? 
                <Link to="/signup" style={{textDecoration:"none"}}>
                <span className = {styles.span}> Sign Up </span>
                </Link>
               </p>
            </div>
            
        </div>
    )
}

export default SignupLeft;